// Module
var code = "<div layout=\"column\" class=\"full-height\"> <div flex id=\"calendar\" ui-calendar=\"$ctrl.calendarOptions\" ng-model=\"$ctrl.eventSources\" calendar=\"calendar\"> </div> </div> ";
// Exports
export default code;